import React from 'react';
import { useAuth } from './AuthContext';
import NoPermissionPage from '../pages/NoPermissionPage';
import { useLocation } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const { user, loading, emailVerified } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return <NoPermissionPage />;
  if (!emailVerified && location.pathname !== '/settings') {
    return (
      <NoPermissionPage showLoginLink={false} />
    );
  }
  return children;
}
